<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <!-- Content -->

    <form name="shortCodeForm" [formGroup]="shortCodeForm" class="tax-type-form w-100-p p-20" fxLayout="column" fxFlex>
        <mat-label>{{ "Short Code" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="value" formControlName="value" mat-maxlength="50" placeholder=""
                [readonly]="action === recordAction.View" required />
        </mat-form-field>
        <mat-label>{{ "Descripción" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="description" formControlName="description" mat-maxlength="100" placeholder=""
                [readonly]="action === recordAction.View" required />
        </mat-form-field>
        <mat-label>{{ "Tipo" | translate }}</mat-label>
        <mat-form-field appearance="outline">
            <mat-select placeholder="" formControlName="type" (valueChange)="getMask($event)" required>
                <mat-option>-- {{ "Seleccionar" | translate }} --</mat-option>
                <mat-option *ngFor="let type of typeOptions" [value]="type.value">
                    {{ type.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <ng-container *ngIf="isMaskEnable">
            <mat-label>{{ "Mask" | translate }}</mat-label>
            <mat-form-field appearance="outline">
                <mat-select placeholder="" formControlName="mask" (valueChange)="setMaskInDescription($event)" required>
                    <mat-option>-- {{ "Seleccionar" | translate }} --</mat-option>
                    <mat-option *ngFor="let maskValue of maskList" [value]="maskValue.mask">
                        {{ maskValue.mask }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>

        <div class="h-100-p w-100-p">
            <button mat-raised-button (click)="performAction()" class="save-button w-100-p"
                [disabled]="shortCodeForm.invalid" aria-label="GUARDAR">
                <span class="material-icons-outlined"> save </span>
                <span> {{ "Guardar" | translate }}</span>
            </button>
        </div>
    </form>
    <!-- Content -->

    <!-- Buttons -->

    <!-- Buttons -->
</wtf-dialogcontent>